// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.empty-card-pp img[data-v-341da86f] {\n  width: var(--341da86f-iconSize);\n}\n.empty-card-pp h6[data-v-341da86f] {\n  color: var(--green);\n  font-size: 0.9rem !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
